import { render, staticRenderFns } from "./ModalLinkPresaleToProject.vue?vue&type=template&id=3b5a021c"
import script from "./ModalLinkPresaleToProject.vue?vue&type=script&lang=js"
export * from "./ModalLinkPresaleToProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports